import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-visitor`

let api = {
  // 概览
  getVisitorOverview: `${baseUrl}/visitorOverview/getVisitorOverview`,

  getVisitorRegisterRecordStatictics: `${baseUrl}/visitorOverview/getVisitorRegisterRecordStatictics`,

  getVisitorBookingRecordStatictics: `${baseUrl}/visitorOverview/getVisitorBookingRecordStatictics`,

  // 获取设备分页
  getDevicePage: `${baseUrl}/visitorDevice/getPage`,

  // 查询访客配置
  getVisitorConfig: `${baseUrl}/visitorConfig/getVisitorConfig`,

  // 修改访客配置
  updateVisitorConfig: `${baseUrl}/visitorConfig/updateVisitorConfig`,

  // 添加设备
  addDevice: `${baseUrl}/visitorDevice/add`,

  // 修改设备
  updateDevice: `${baseUrl}/visitorDevice/update`,

  // 删除设备
  deleteDevice: `${baseUrl}/visitorDevice/deleteByCodes`,

  // 获取登记记录分页
  getVisitorRegisterRecordPage: `${baseUrl}/visitorRegisterRecord/getPage`,

  // 获取登记申请分页
  getVisitorRegisterPage: `${baseUrl}/visitorRegisterRecord/getVisitorRegisterPage`,

  // 登记通过
  passTheVisitor: `${baseUrl}/visitorRegisterRecord/passTheVisitor`,

  // 登记驳回
  notPassTheVisitor: `${baseUrl}/visitorRegisterRecord/notPassTheVisitor`,

  // 获取预约记录分页
  getBookingPage: `${baseUrl}/booking/getPage`,

  // 获取来访人分页
  getVisitorsPage: `${baseUrl}/booking/getVisitorsPage`,

  // 获取预约人信息
  getInvitedPersonListByBookingCode: `${baseUrl}/booking/getInvitedPersonListByBookingCode`,

  // 获取刷卡记录分页
  getRecordPage: `${baseUrl}/record/getPage`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/Visitor.js